import { render, staticRenderFns } from "./SortBy.vue?vue&type=template&id=79b26138"
import script from "./SortBy.vue?vue&type=script&lang=js"
export * from "./SortBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.97.1_webpack-cli@4.10.0___handlebars@4.7.8_lod_mbct3ghtlsccta64wt23el5w4u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports